import * as React from "react";
import { cn } from "~/lib/utils";

export interface SkeletonProps extends React.HTMLAttributes<HTMLDivElement> {
  lines?: number;
  width?: string | number;
  circle?: boolean;
  rows?: number;
}

export const Skeleton = React.forwardRef<HTMLDivElement, SkeletonProps>(
  (
    {
      lines = 1,
      width,
      circle = false,
      rows = 1,
      className,
      "aria-label": ariaLabel = "Loading",
      ...props
    },
    ref
  ) => {
    const lineCount = rows * lines;
    const lineChildren = Array.from({ length: lineCount }, (_, i) => (
      <div
        key={i}
        className="h-4 rounded-sm bg-surface-2"
      />
    ));

    const style = {
      ...props.style,
      ...(width !== undefined && {
        width: typeof width === "number" ? `${width}px` : width,
      }),
    };

    return (
      <div
        ref={ref}
        role="status"
        aria-label={ariaLabel}
        aria-busy="true"
        className={cn(
          "animate-pulse motion-reduce:animate-none bg-surface-2 rounded-sm",
          {
            "rounded-full aspect-square": circle,
          },
          className
        )}
        style={style}
        {...props}
      >
        {!circle && lineChildren}
      </div>
    );
  }
);
Skeleton.displayName = "Skeleton";
